module.exports = __webpack_public_path__ + "img/programme_icon_baokuan@3x.27e0a881.png";